import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { WindowUtilitiesService } from '@grid-ui/common';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { DataWizardExtractNotificationService } from '../../../services';
import { ExtractDownloadedFromNotificationBar } from '../../../store/actions/notifications';
import * as fromNotificationBar from '../../../store/reducers';

@Component({
  selector: 'mc-extract-notification',
  templateUrl: './extract-notification.component.html',
  styleUrls: ['./extract-notification.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExtractNotificationComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  public complete$: Observable<boolean>;
  public extractDownloadUrl: string;
  private downloadExtractUrlSubscription: Subscription;

  constructor(
    private windowUtilitiesService: WindowUtilitiesService,
    private readonly extractNotificationService: DataWizardExtractNotificationService,
    private readonly store: Store<fromNotificationBar.State>,
  ) {}

  public ngOnInit(): void {
    this.complete$ = this.extractNotificationService.extractComplete();

    this.downloadExtractUrlSubscription = this.extractNotificationService
      .getDownloadExtractUrl()
      .subscribe((extractDownloadUrl: string) => {
        this.extractDownloadUrl = extractDownloadUrl;
      });
  }

  public ngOnDestroy(): void {
    this.downloadExtractUrlSubscription.unsubscribe();
  }

  public cancel(): void {
    this.extractNotificationService.cancel();
  }

  public downloadExtract(): void {
    this.extractNotificationService.downloadExtract();
    this.store.dispatch(new ExtractDownloadedFromNotificationBar(this.extractDownloadUrl));
    this.windowUtilitiesService.downloadAsset(this.extractDownloadUrl);
    this.close.emit();
  }

  public closeNotification(): void {
    this.extractNotificationService.closeNotification();
    this.close.emit();
  }
}
